import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

export const LOGIN_URL = `http://${baseUrl}/login`;
const domain = process.env.REACT_APP_API_DOMAIN;
const isMM6MM = process.env.REACT_APP_PROJECT_ID === "mm6mm";

export const login = (queryParams, isFromTelegram) => {
  return axios
    .post(`${window.location.protocol}//admin-bo.${domain}/api/index.php`, {
      url: `http://${baseUrl}/${isMM6MM && isFromTelegram ? 'Agent23.ashx' : 'Agent1.ashx'}`,
      data: queryParams,
    })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const fetchIPAddress = () => {
  return axios
    .get(`${window.location.protocol}//api.${domain}/clientIP.php`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      if (error.response) {
        return error.response;
      } else {
        return error;
      }
    });
};

export const getUserData = () => {
  const data = localStorage.getItem("UserData");
  if (!data) {
    return;
  }

  try {
    const auth = JSON.parse(data);
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error("AUTH LOCAL STORAGE PARSE ERROR", error);
  }
};
